import pokemonReducer from "../slices/PokemonSlice"
import appGlobalReducer from "../slices/appGlobalSlide"

const rootReducer = {
  pokemon: pokemonReducer,
  appGlobal: appGlobalReducer,
}

export default rootReducer
